// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  account: `account`,
  action: 'Action',
  active: 'Active',
  // Client
  active_placement: 'Active Placement',
  // Common
  add: 'Add',
  add_new: 'Add New',
  address: 'Address',
  administrator: 'Administrator',
  age: 'Age',
  agreement_exists: 'Agreement Exists',
  agreement_legal_basis: 'Team room to support the effort',
  all: 'All',
  all_clear: 'All Clear',

  amount_of_placements: 'Amount of Placements',

  amount_of_register_leaders: 'Amount of Register Leaders',

  animal_description: 'Describe the animal.',

  animals: 'Animals',

  app: `app`,

  back_to_list: 'Back To List',

  bank: `bank`,

  bank_account_number: 'Bank Account Number',

  banking: `banking`,

  blog: `blog`,

  booking: `booking`,

  BUSINESS_ENTITY: 'Business Entity',

  calendar: `calendar`,

  cancel: 'Cancel',

  cards: `cards`,

  care_fee_per_day: 'Care fee per 24h',

  case_manager: 'Case Manager',

  certain_interest: 'Certain interest',

  change: 'Change',

  // User
  change_password: 'Change Password',

  chat: `chat`,

  citizenship: 'Citizenship',

  city: 'City',

  // Documents
  clear: 'Clear',

  client: 'Client',

  client_id: 'Client ID',

  clients: 'Clients',
  close: 'Close',

  close_extended_search: 'Close Extended Search',

  closing_date: 'Closing Date',

  // Company
  company: 'Company',

  competence: 'Competence',

  confirm_delete_row_msg: 'Are you sure want to delete this item?',

  confirm_delete_rows_msg: 'Are you sure want to delete',

  confirm_delete_rows_msg_items: 'items?',

  confirm_password: 'Confirm Password',

  contact_person: 'Contact Person',

  contact_persons: 'Contact Persons',

  copy_link: 'Copy Link',

  create: `create`,

  create_new_folder: 'New Folder',

  current_password: 'Current Password',

  custom: 'Custom',

  // Customer
  customer: 'Customer',

  customers: 'Customers',

  dashboard: 'Dashboard',

  date_of_sign_up: 'Date of Sign Up',

  date_of_signup: 'Date of Signup',

  date_range: 'Date Range',

  delete: 'Delete',

  demo: {
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
    title: `English`,
  },

  description: 'Description',

  details: `details`,

  do_you_want_to_stay_log_in: 'Do you want to stay logged in ?',

  docs: {
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
    hi: `Hi`,
  },

  document_type: 'Document Type',

  documents: 'Documents',

  // Dashboard
  documents_duedate: 'Documents Duedate',

  download: 'Download',

  due_date: 'Due Date',

  edit: 'Edit',

  email: 'Email',

  email_address: 'Email address',

  end: 'End',

  end_date: 'End Date',

  end_placement: 'End Placement',

  ended: 'Ended',

  enter_keyword: 'Enter keyword',

  error: 'Error',

  extended_search: 'Extended Search',

  extra_reinforced_family_home: 'Extra reinforced family home',

  family_home: 'Family home',

  female: 'Female',

  file_name: 'Filename',

  files: 'Files',

  first_name: 'First Name',

  folder: 'Folder',

  folders: 'Folders',

  forgot_password: 'Forgot password?',

  foster_families: 'Foster Families',

  foster_family: 'Foster Family',

  FRAMEWORK_AGREEMENT: 'Framework Agreement',

  from: 'From',

  full: 'Full',

  gender: 'Gender',

  general: `general`,

  gross_salary: 'Gross Salary',

  has_animals: 'Do the home have animals?',

  HAS_ASSIGNMENT_AGREEMENT: 'Has Assignment Agreement',

  HAS_PLACEMENT_AGREEMENT: 'Has Placement Agreement',

  has_smokers: 'Do the home have smokers?',

  home: 'Home',

  implementation_plan: 'Implementation Plan',

  inactivated: 'Inactivated',

  inactive: 'Inactive',

  inactive_placement: 'Inactive Placement',

  internal_comments: 'Internal Comments',

  invoice: `invoice`,

  invoice_address: 'Invoice Address',

  invoice_city: 'Invoice City',

  invoice_postcode: 'Invoice Postcode',

  IS_READY: 'Ready',

  is_required: 'is required',

  // Shared Document
  issuer: 'Issuer',

  item_by_roles: `item by roles`,

  item_caption: `item caption`,

  item_disabled: `item disabled`,

  item_external_link: `item external link`,

  item_label: `item label`,

  joined: 'Joined',

  kanban: `kanban`,

  language_spoken: 'Language Spoken',

  last_month: 'Last Month',

  last_name: 'Last Name',

  last_year: 'Last Year',

  last30: 'Last 30 Days',

  last7: 'Last 7 Days',

  last90: 'Last 90 Days',

  list: 'List',

  login: 'Login',

  logout: 'Logout',

  mail: `mail`,

  main_password: 'Main Password',

  male: 'Male',

  management: `management`,

  manager: 'Manager',

  managers: 'Managers',

  menu_level: `menu level`,

  menu_level_2a: `menu level 2a`,

  menu_level_2b: `menu level 2b`,

  menu_level_3a: `menu level 3a`,

  menu_level_3b: `menu level 3b`,

  menu_level_4a: `menu level 4a`,

  menu_level_4b: `menu level 4b`,

  message: 'Message',

  mobile_phone_number: 'Mobile Phone Number',

  modified: 'Modified',

  month_to_date: 'Month To Date',

  mother_language: 'Mother language',

  MUNICIPALITY: 'Municipality',

  name: 'Name',

  new: 'New',

  // Foster Family
  new_foster_family: 'New Foster Family',

  new_password: 'New Password',

  next_step: 'Next Step',

  no: 'No',

  no_data: 'No Data',

  NOTES: 'Notes',

  // Notifications
  notification: {
    failure: {
      default: 'Failed',
      upload: 'Upload failed!',
    },
    info: {
      copy: 'Copied',
    },
    success: {
      change_password: 'Password changed successfully!',
      create: 'Created successfully!',
      delete: 'Deleted successfully!',
      save: 'Saved successfully!',
      send_email: 'Sent an email successfully!',
      send_share_email: 'Sent a share email successfully!',
      set_password: 'Set password successfully!',
      update: 'Updated successfully!',
      upload: 'Uploaded successfully!',
    },
    warning: {
      invalid_url: 'Invalid url!',
      no_company: 'Cannot find the current company!',
      no_logout: 'Unable to logout!',
    },
  },

  nursing_home: 'Nursing home',

  only_admin_can_see_this_item: `Only admin can see this item`,

  open: 'Open',

  org_name: 'Org Name',

  organization_name: 'Organization Name',

  organization_number: 'Organization Number',

  other_cases: `other cases`,

  other_info_about_placement: 'Other info about Placement',

  other_information: 'Other information',

  overhead_per_day: 'Overhead per day',

  overhead_per_month: 'Overhead per month',

  password: 'Password',

  PAYROLL_SCHEDULE: 'Payroll Schedule',

  pending: 'Pending',

  personal_number: 'Personal number',

  phone: 'Phone',

  phone_number: 'Phone Number',
  place: 'Place',
  // Placement
  placement: 'Placement',

  placement_agreement: 'Placement agreement',

  placement_character: 'Placement Character',

  placement_date: 'Placement Date',

  PLACEMENT_NOT_READY_EXPLANATION:
    'Placement is not ready. Placement must have a social reference number, an assignment agreement, and a placement agreement.',

  PLACEMENT_TYPE: 'Placement Type',

  placements: 'Placements',

  post: `post`,

  postcode: 'Postcode',

  posts: `posts`,

  PRICE_SEK: '{{value}} SEK',

  product: `product`,

  PROFILE: 'Profile',

  // Profile
  profile: 'Profile',

  profiles: 'Profiles',

  purpose_of_insertion: 'Purpose of Insertion',

  rank: 'Rank',

  ready: 'Ready',

  reason: 'Reason',

  reason_for_insertion: 'Reason for Insertion',

  register_leader: 'Register Leader',

  reinforced_family_home: 'Reinforced family home',

  relationship: 'Relationship',

  rename: 'Rename',

  require_select_customer_msg:
    'You must select customer before selecting Manager',

  reset: 'Reset',

  // Reset Password
  reset_password: 'Reset password',

  responsibility: 'Responsibility',

  responsible: 'Responsible',

  responsible_party: 'Select Responsible Party',

  role: 'Role',

  rows: 'Rows',

  rows_per_page: 'Rows per page',

  salary_per_day: 'Salary per day',

  salary_per_month: 'Salary per month',

  save: 'Save',

  save_changes: 'Save Changes',

  search: 'Search',

  secure_identity: 'Secure Identity',

  select: 'Select',

  select_all: 'Select All',

  select_date: 'Select Date',

  select_date_range: 'Select Date Range',

  send_encrypted: 'Send Encrypted',

  set_password: 'Set Password',

  settings: 'Settings',

  share: 'Share',

  shop: `shop`,

  show_description: 'Show Description',

  // Login
  sign_in_to_safepoint: 'Sign in to Safepoint',

  smokers: 'Smokers',

  social_register_data: 'Social Register Data',

  social_security_number: 'Social Security Number',

  social_worker: 'Social Worker',

  staff: 'Staff',

  start_date: 'Start Date',

  state: 'State',

  status: 'Status',

  step: 'Step',

  support_nearby_living: 'Support/Nearby living',

  surname: 'Surname',

  SWITCH_COMPANY: 'Switch Company',

  the_bailiff: 'The Bailiff',

  the_insurance_fund: 'The Insurance Fund',

  the_police: 'The Police',

  the_swedish_transport_agency: 'The Swedish Transport Agency',

  to: 'To',

  today: 'Today',

  tools: 'Tools',

  total_active_placements_from_others:
    'Amount of active placements from others',

  total_adults_in_home: 'Amount of adults in home',

  total_adults_reduced_working_hours_due_to_placement:
    'Amount of adults that have reduced working hours due to placement',

  total_free_rooms_in_home: 'Amount of free rooms in home',

  total_own_children_in_home: 'Amount of own children in the home',

  total_placement_capacity_in_the_home:
    'Amount of existing ongoing placements via other companies/municipalities',

  total_placements_capacity_for_our_company:
    'Amount of placements capacity for our company',

  total_rooms_in_home: 'Amount of rooms in home',

  treatment_family: 'Treatmenet family',

  type: 'Type',

  type_of_insertion: 'Type of Insertion',

  unit: 'Unit',

  unknown: 'Unknown',

  upload_file: 'Upload File',

  uploading: 'Uploading',

  user: 'User',

  users: 'Users',

  validate: 'Validate',

  vault: 'Vault',

  verification_password: 'Verification Password',

  view: 'View',

  visiting_address: 'Visiting Address',

  visiting_city: 'Visiting City',

  visiting_postcode: 'Visiting Postcode',

  warning: 'Warning',

  week: 'Week',

  week_to_date: 'Week To Date',

  year_to_date: 'Year To Date',

  yes: 'Yes',

  yesterday: 'Yesterday',

  // Idle Warning
  you_have_been_inactive: 'You have been inactive, you will be logged out soon',
};

export default en;
